// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5JLuB","title":"Header_title__PmS8+"};